/* eslint-disable react/no-unstable-nested-components */
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../Core/Components/CustomTable";
import HubStationIcon from "../../Common/Svgs/HubStationIcon";
import { getTableContainerHeight } from "../../Utils/getTableContainerHeight";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";
import { hubColumns } from "./constants";
import { updateHub } from "../../Redux/Slices/hubs.slice";

const LOCAL_DEFAULT_LIMIT = 10;

const TableView = ({ currentPage, setCurrentPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { hubEnergyBreakdown } = useSelector((state) => state.hubs);

  const tableContainerRef = useRef();

  const getTableContainerStyle = () => {
    if (hubEnergyBreakdown?.result?.length) {
      return "h-[calc(100vh-72px-70px-160px-60px-40px)] overflow-y-scroll";
    }
    return "h-[calc(100vh-72px-70px-160px-60px-40px)]";
  };

  const handleRowClick = (record) => {
    dispatch(
      updateHub({
        key: "selectedHub",
        value: record,
      }),
    );

    navigate(`/hub-detail/${record.id}`);
  };

  return (
    <div
      className={`border-b border-light-grey ${getTableContainerStyle()}`}
      ref={tableContainerRef}
    >
      <CustomTable
        // scrollX={0}
        disableScroll
        columns={hubColumns}
        data={hubEnergyBreakdown?.result}
        onRowClick={handleRowClick}
        emptyState={
          <HubStationIcon className="w-6 h-6 fill-none stroke-dark-grey-text" />
        }
        emptyStateHeight={getTableContainerHeight(tableContainerRef)}
        rowClassName="group cursor-pointer"
        pagination={{
          pageSize: LOCAL_DEFAULT_LIMIT,
          total: hubEnergyBreakdown?.totalRecords,
          showSizeChanger: false,
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
          itemRender: (current, type, originalElement) => {
            const lastPage = hubEnergyBreakdown.totalRecords / current;

            if (type === "prev" && current === 0) {
              return (
                <button
                  type="button"
                  className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "prev" && current > 0) {
              return (
                <button
                  type="button"
                  className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "next" && lastPage <= 10) {
              return (
                <button
                  type="button"
                  className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  style={{ pointerEvents: "none" }}
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "next") {
              return (
                <button
                  type="button"
                  className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            return originalElement;
          },
        }}
      />
    </div>
  );
};

export default TableView;
